import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import {
  ButtonWrapper,
  CancelButton,
  DialogHeader,
  DialogHeading,
  SaveButton,
} from '../../../../../../Episode/Episode.Styled';
import FormSuccess from '../../../../../../common/Forms/FormSuccess';
import DropdownFormInput from '../../../../../../common/Forms/DropdownForm';
import { setContactKeyId } from '../../../../../../../redux/organization/organizationTabs/organizationSap/organizationSapActivitiesContacts/organizationSapActivitiesContactsSlice';
import {
  postStopApi,
  setStopApi,
} from '../../../../../../../services/StopApi/StopApi';
import { ORGANIZATION_SAP_ACTIVITIES_UPDATE_URL } from '../../../../../../../constants';

const SapActivitiesDialog = (props) => {
  const { open, setOpen, openBackdrop, authToken, orgId, fetchData } = props;

  const dispatch = useDispatch();
  const [formSuccess, setFormSuccess] = useState(false);
  const [
    isNewOrganizationSapActivitiesForm,
    setIsNewOrganizationSapActivitiesForm,
  ] = useState(false);

  const organizationSapActivitiesContactForm = useSelector(
    (state) => state.organizationSapActivitiesContactForm
  );

  const organizationReferenceData = useSelector(
    (state) => state.organizationReferenceData
  );
  const { contactKeyList, phoneList, faxList } = organizationReferenceData;

  const { orgCntId, contactKey, contactKeyId, phone, fax } =
    organizationSapActivitiesContactForm;

  const defaultValue = {
    orgCntId: orgCntId,
    contactKey: contactKey,
    contactKeyId: contactKeyId ? contactKeyId : '',
    phone: phone,
    fax: fax,
  };

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
    //resolver: yupResolver(schema),
  });
  const { handleSubmit, reset, control, setValue, watch, register, formState } =
    useFunction;
  const { isValid, dirtyFields, errors } = formState;

  useEffect(() => {
    reset(defaultValue);
  }, [
    defaultValue.orgCntId,
    defaultValue.contactKey,
    defaultValue.contactKeyId,
    defaultValue.phone,
    defaultValue.fax,
  ]);

  const handleClose = () => {
    setOpen(false);
    reset(defaultValue);
  };

  const onSubmit = () => {
    const url = `${ORGANIZATION_SAP_ACTIVITIES_UPDATE_URL}`;
    const authorization = authToken;
    if (
      organizationSapActivitiesContactForm?.newOrganizationSapActivitiesForm ===
      true
    ) {
      const payload = {
        orgId: orgId,
        orgCntId: 0,
        contactKey: contactKeyId,
      };
      postStopApi({ url, payload, authorization }).then((response) => {
        console.log(response);
        if (response.succeeded === true) {
          fetchData();
          setFormSuccess(true);
          setIsNewOrganizationSapActivitiesForm(true);
          setOpen(false);
        }
      }).catch((e) => alert(e));
    } else {
      const payload = {
        orgId: orgId,
        orgCntId: orgCntId,
        contactKey: contactKeyId,
      };
      setStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          fetchData();
          setFormSuccess(true);
          setIsNewOrganizationSapActivitiesForm(false);
          setOpen(false);
        }
      }).catch((e) => alert(e));
    }
  };

  return (
    <>
      <Dialog
        open={open}
        PaperProps={{
          sx: {
            maxWidth: 'unset',
            width: '400px',
            maxHeight: 'unset',
          },
        }}
      >
        {openBackdrop ? (
          <Backdrop
            sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={openBackdrop}
          >
            <CircularProgress />
          </Backdrop>
        ) : (
          <>
            <DialogHeader>
              <DialogHeading variant='h5'>
                Contact ID : {defaultValue?.orgCntId}
              </DialogHeading>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </DialogHeader>
            <Box style={{ padding: '10px 40px' }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <DropdownFormInput
                    name='contactKeyId'
                    control={control}
                    options={contactKeyList}
                    defaultId={defaultValue?.contactKeyId}
                    label='Contact Key'
                    register={register('contactKeyId', {
                      onChange: (e) =>
                        dispatch(setContactKeyId(e.target.value)),
                    })}
                  />
                  <DropdownFormInput
                    name='contactKeyId'
                    control={control}
                    options={phoneList}
                    disabled={true}
                    defaultId={defaultValue?.contactKeyId}
                    label='Phone'
                  />
                  <DropdownFormInput
                    name='contactKeyId'
                    control={control}
                    options={faxList}
                    disabled={true}
                    defaultId={defaultValue?.contactKeyId}
                    label='fax'
                  />
                </Grid>
              </Grid>
              <ButtonWrapper>
                <CancelButton
                  variant='contained'
                  //disabled={_.isEmpty(dirtyFields) || !isValid} {defaultValue?.authId}
                  onClick={handleClose}
                >
                  Cancel
                </CancelButton>
                <SaveButton
                  variant='contained'
                  //disabled={_.isEmpty(dirtyFields) || !isValid}
                  onClick={handleSubmit(onSubmit)}
                >
                  Save
                </SaveButton>
              </ButtonWrapper>
            </Box>
          </>
        )}
      </Dialog>
      <FormSuccess
        formSuccess={formSuccess}
        setFormSuccess={setFormSuccess}
        isNewForm={isNewOrganizationSapActivitiesForm}
      />
    </>
  );
};

export default SapActivitiesDialog;
